module.exports = __webpack_public_path__ + "themes/non-default/vennBackground.9d5908c11b91ad2f0c1ba57292e46dee.svg";